import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { QueryParamProvider as ContextProvider } from 'use-query-params';

export const CustomQueryParamProvider = ({ children }) => {
  const router = useRouter();
  const match = router.asPath.match(/[^?]+/);
  const pathname = match ? match[0] : router.asPath;

  const location = useMemo(
    () =>
      process.browser
        ? window.location
        : { search: router.asPath.replace(/[^?]+/u, '') },
    [router.asPath],
  );

  const history = useMemo(
    () => ({
      push: ({ search }) =>
        router.push(
          { pathname: router.pathname, query: router.query },
          { search, pathname },
          { shallow: true },
        ),
      replace: ({ search }) =>
        router.replace(
          { pathname: router.pathname, query: router.query },
          { search, pathname },
          { shallow: true },
        ),
    }),
    [pathname, router],
  );

  return (
    <ContextProvider history={history} location={location}>
      {children}
    </ContextProvider>
  );
};

CustomQueryParamProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const QueryParamProvider = memo(CustomQueryParamProvider);
